import React from 'react';
import './NewPage.css';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ProductHub from '../../components/ProductHub/ProductHub';
import Banner from '../../components/Banner/Banner';
import NewPageBanner from '../../assets/banner5.jpg'

const NewPage = () => {
  return (
    <div className='page__wrapper'>
        <Navbar />
        <div className='auth__container'>
            <div className='shopAll__container'>
                <Banner imgSrc={NewPageBanner} imgAlt={"Shop New Items from Alex Menswear"} />
                <ProductHub />
                <ProductHub />
            </div>
        
        </div>
        <Footer />
    </div>
  )
}

export default NewPage;
